import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components';

/** Verwerfen und Apartmentwechsel löschen Eingaben nie ohne Rückfrage. */
export function ConfigurationDiscardDialog({
  open,
  switching,
  onDiscard,
  onKeep,
}: {
  open: boolean;
  /** Wechsel des Apartments statt reinem Verwerfen. */
  switching: boolean;
  onDiscard: () => void;
  onKeep: () => void;
}) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onKeep()}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Änderungen verwerfen?</DialogTitle>
          <DialogDescription>
            {switching
              ? 'Die Änderungen an diesem Apartment sind noch nicht gespeichert. Beim Wechsel gehen sie verloren.'
              : 'Alle Eingaben seit dem letzten Speichern gehen verloren. Es gilt wieder der gespeicherte Stand.'}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button type="button" variant="ghost" className="min-h-11" onClick={onKeep}>
            Weiter bearbeiten
          </Button>
          <Button type="button" variant="destructive" className="min-h-11" onClick={onDiscard}>
            {switching ? 'Verwerfen und wechseln' : 'Verwerfen'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
